import { render, staticRenderFns } from "./pre_btn_control_easy.vue?vue&type=template&id=b63397f4&scoped=true"
import script from "./pre_btn_control_easy.vue?vue&type=script&lang=js"
export * from "./pre_btn_control_easy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63397f4",
  null
  
)

export default component.exports